import AprovarIndisponibilidade, {
  FinderAprovarIndisponibilidades,
  RetornoAprovarIndisponibilidade,
} from 'Interface/AprovarIndisponibilidades';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'AprovarIndisponibilidades';

const url = '/aprovar-indisponibilidades';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag, 'Indisponibilidades'],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarAprovarIndisponibilidades: construtor.query<
        FinderAprovarIndisponibilidades,
        Parametros | void
      >({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.aprovar_indisponibilidades
            ? [
                ...resultado.aprovar_indisponibilidades.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarAprovarIndisponibilidade: construtor.query<
        RetornoAprovarIndisponibilidade,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarAprovarIndisponibilidade: construtor.mutation<
        AprovarIndisponibilidade,
        Partial<AprovarIndisponibilidade>
      >({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: dados,
        }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarAprovarIndisponibilidade: construtor.mutation<
        AprovarIndisponibilidade,
        Partial<AprovarIndisponibilidade> &
          Pick<AprovarIndisponibilidade, 'id'> & { options?: Parametros }
      >({
        query: ({ id, options, ...dados }) => ({
          url: `${url}/${id}?${paramsParaString({ options })}`,
          method: 'PUT',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id, indisponibilidade_id }) =>
          !erro ? [{ type: tag, id }, { type: 'Indisponibilidades', id: indisponibilidade_id }] : [],
      }),
      removerAprovarIndisponibilidade: construtor.mutation<
        AprovarIndisponibilidade,
        Partial<AprovarIndisponibilidade> & Pick<AprovarIndisponibilidade, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'POST',
          body: formData(dados, 'DELETE'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarAprovarIndisponibilidadesQuery,
  useRecuperarAprovarIndisponibilidadeQuery,
  useAdicionarAprovarIndisponibilidadeMutation,
  useEditarAprovarIndisponibilidadeMutation,
  useRemoverAprovarIndisponibilidadeMutation,
} = apiExtendida;
